import {
  FiType,
  FiHash,
  FiCalendar,
  FiMail,
  FiPhone,
  FiAlignLeft,
  FiCheckSquare,
  FiChevronDown,
  FiCircle,
  FiMapPin,
  FiUpload,
  FiEdit3,
  FiGrid,
  FiFileText,
  FiLayers,
  FiLayout,
} from "react-icons/fi";

export const FIELD_TYPE_LABELS = {
  text: "Short text",
  number: "Number",
  date: "Date",
  email: "Email",
  phone: "Phone",
  textarea: "Long text",
  checkbox: "Checkbox",
  select: "Dropdown",
  radio: "Radio",
  address: "Address",
  file: "File upload",
  signature: "Signature",
  table: "Table",
  content: "Content block",
  sub_section: "Sub-section",
  section: "Section",
};

export const PALETTE_GROUP_THEMES = {
  structure: "theme-teal",
  basic: "theme-blue",
  choice: "theme-violet",
  advanced: "theme-amber",
};

/** Top-level canvas building blocks — sections and sub-sections. */
export const PALETTE_STRUCTURE_ITEMS = [
  {
    type: "section",
    label: "Section",
    icon: FiLayout,
    description: "New form step or page",
  },
  {
    type: "sub_section",
    label: "Sub-section",
    icon: FiLayers,
    description: "Grouped fields inside a section",
  },
];

export const PALETTE_FIELD_GROUPS = [
  {
    id: "basic",
    label: "Basic inputs",
    items: [
      { type: "text", label: "Short text", icon: FiType, description: "Single-line answer" },
      { type: "textarea", label: "Long text", icon: FiAlignLeft, description: "Multi-line answer" },
      { type: "number", label: "Number", icon: FiHash, description: "Numeric input" },
      { type: "date", label: "Date", icon: FiCalendar, description: "Date picker" },
      { type: "email", label: "Email", icon: FiMail, description: "Email address" },
      { type: "phone", label: "Phone", icon: FiPhone, description: "Phone number" },
    ],
  },
  {
    id: "choice",
    label: "Choices",
    items: [
      { type: "checkbox", label: "Checkbox", icon: FiCheckSquare, description: "Yes / no or consent" },
      { type: "radio", label: "Radio", icon: FiCircle, description: "Pick one option" },
      { type: "select", label: "Dropdown", icon: FiChevronDown, description: "Select from list" },
    ],
  },
  {
    id: "advanced",
    label: "Advanced",
    items: [
      { type: "address", label: "Address", icon: FiMapPin, description: "Structured address" },
      { type: "file", label: "File upload", icon: FiUpload, description: "Attach a document" },
      { type: "signature", label: "Signature", icon: FiEdit3, description: "Capture signature" },
      { type: "table", label: "Table", icon: FiGrid, description: "Rows and columns" },
      { type: "content", label: "Content block", icon: FiFileText, description: "Instructions or legal text" },
    ],
  },
];

/** All palette groups including structure (for search/filter helpers). */
export const PALETTE_GROUPS = [
  { id: "structure", label: "Structure", items: PALETTE_STRUCTURE_ITEMS },
  ...PALETTE_FIELD_GROUPS,
];

export const fieldTypeLabel = (type) =>
  FIELD_TYPE_LABELS[type] ?? type?.replace(/_/g, " ") ?? "Field";

export const PREVIEW_FIELD_PLACEHOLDERS = {
  text: "Enter text…",
  number: "Enter a number…",
  email: "name@example.com",
  phone: "Enter phone number…",
  textarea: "Enter a detailed response…",
  date: "Select a date",
  select: "Choose an option",
};

export const previewFieldPlaceholder = (type) =>
  PREVIEW_FIELD_PLACEHOLDERS[type] ?? "Enter a value…";
